import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY


export const getUserById = async (id) => {
    try {
        if (id) {
            console.log("Fetching user with ID:", id);
        }
        // Correct way to send ID as a query parameter
        const response = await api.get(`${urlApi}/talentoHumano/getOperatorById`, {
            params: {
                id: id
            }
        });
        console.log("User data fetched successfully:", response.data);
        return response.data[0];
    } catch (error) {
        console.error("Error fetching user by ID:", error);
        throw error;
    }
}

export const getStatusList = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getEstatus`);

        return response.data;
    } catch (error) {
        console.error("Error fetching status list:", error);
        return []
    }
}

export const getCivilSates = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getCivilState`);
        console.log("Civil states fetched successfully:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching civil states:", error);
        throw error;
    }
}

export const getLicenseTypes = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getLicences`);
        console.log("Licences fetched successfully:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching licences:", error);
        throw error;
    }
}

export const getScholarTypes = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getScholarTypes`);
        console.log("Scholar types fetched successfully:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching scholar types:", error);
        throw error;
    }
}

export const updateUser = async (userData) => {
    try {
        console.log("Updating user with data:", userData);
        const response = await api.patch(`${urlApi}/talentoHumano/updateChofer`, userData);
        console.log("User updated successfully:", response.data);
        Swal.fire({
            icon: "success",
            title: "Usuario actualizado correctamente",
            showConfirmButton: false,
            timer: 1500,
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error);
        Swal.fire({
            icon: "error",
            title: "Error al actualizar el usuario",
            text: error.response ? error.response.data.message : "Error desconocido",
        });
        throw error;
    }
}


export const getIncapacidadChofer = async (id) => {
    try {
        const incapacidad = await api.get(`${urlApi}/talentoHumano/getIncapacidadesOperador`, {
            params: {
                id: id
            }
        });

        console.log("data", incapacidad);

        return incapacidad.data;
    } catch (error) {
        console.error("Error getting chofer", error);
    }
}


export const getActasAdmin = async (id) => {
    try {

        const actas = await api.get(`${urlApi}/talentoHumano/getActasAdministrativas`, {
            params: {
                id: id
            }
        });

        return actas.data;
    } catch (error) {
        console.error("Error getting chofer actas", error);
    }
}

export const postNuevaActa = async (acta) => {
    try {
        const payload = {acta: normalizeActa(acta)};
        const res = await api.post(`${urlApi}/talentoHumano/postActaAdministrativa`, payload);
        return res.data.success;
    } catch (error) {
        console.error('Error posting chofer', error);
    }
};

export const getTypeActas = async () => {

    try {
        const res = await api.get(`${urlApi}/talentoHumano/getTiposActa`);

        return res.data;
    } catch (error) {
        console.error("Error getting tipoActas", error);
    }
}

function normalizeActa(a) {
    return {
        FECHA: a.FECHA ?? a.FECHA_ACTA,          // FECHA_ACTA -> FECHA
        ID_ACTA: a.ID_ACTA ?? a.ID_ACTA,
        ID_USUARIO: a.ID_USUARIO,
        MOTIVO: a.MOTIVO,
        NOMBRE: a.NOMBRE,
        NUM_ACTA: typeof a.NUM_ACTA === 'string' ? parseInt(a.NUM_ACTA, 10) : a.NUM_ACTA,
    };
}

export const deleteActa = async (id) => {

    try {
        const res = await api.get(`${urlApi}/talentoHumano/deleteActaAdministrativa`, {
            params: {
                id: id
            }
        })

        return res.data;
    } catch (e) {
        return e;
    }

}

export const insertIncapacidad = async (data) => {
    try {
        const res = await api.post(`${urlApi}/talentoHumano/insertIncapacidad`, {
            incapacidad: data,
        });
        return res.data;
    } catch (e) {
        console.error("Error inserting incapacidad", e);
    }
}

export const getTiposIncapacidad = async () => {
    try {
        const res = await api.get(`${urlApi}/talentoHumano/getTiposIncapacidad`);
        return res.data;
    } catch (e) {
        console.error("Error getting tipos incapacidad", e);
    }
}

export const uploadNewFile = async (data) => {

    try {
        const res = await api.post(`${urlApi}/talentoHumano/uploadNewDocument`, data);
        console.log(res.data);
        return res.data;
    } catch (error) {
        console.error('Error uploading file:', error);
    }
}

export const getDocuments = async () => {

    try {
        const res = await api.get(`${urlApi}/talentoHumano/getRequiredDocuments`);
        return res.data;
    } catch (error) {
    }
}